<template>
  <b-table responsive
           hover
           :items="items"
           :fields="fields"
           :small="true">
    <template slot="HEAD_termo">
      Registro
    </template>

    <template slot="termo"
              slot-scope="data">
      <input :id="data.item.registro_id"
             type="checkbox"
             :name="data.item.registro_id"
             :value="data.item.registro_id"
             :checked="allSelected"
             @click="checkBox(data.item)">

      <label class="ml-2"
             :for="data.item.registro_id">
        {{ data.item.termo }}
      </label>
    </template>

    <template slot="tipo_livro"
              slot-scope="data">
      {{ getLabelTipoLivro(data.item.tipo_livro) }}
    </template>

    <template slot="nome_registrado"
              slot-scope="data">
      <span v-html="getNomeRegistrado(data.item.pessoa || data.item.pessoas)" />
    </template>

    <template slot="documentos"
              slot-scope="data">
      {{ data.item.qtd_documentos > 0 ? 'Sim' : 'Não' }}
    </template>

    <template slot="acao"
              slot-scope="data">
      <b-button variant="outline-primary"
                @click="verRegistro(data)">
        Ver registro
      </b-button>
    </template>
  </b-table>
</template>

<script>
  import { findTipoLivroByValue } from '@/common/registro'

  export default {
    name: 'ListagemLoteRegistro',
    props: {
      items: {
        type: Array,
        default: []
      },
      selectedAll: {
        type: Boolean,
        default: false
      }
    },
    data () {
      return {
        // Registros selecionados
        allSelected: false,
        selected: [],

        // Tabela
        fields: [
          {
            key: 'termo',
            label: 'Registro',
            thClass: 'header-table'
          },
          {
            key: 'folha',
            label: 'Folha',
            sortable: true,
            thClass: 'header-table'
          },
          {
            key: 'num_livro',
            label: 'Livro',
            sortable: true,
            thClass: 'header-table'
          },
          {
            key: 'acervo',
            label: 'Acervo',
            sortable: true,
            thClass: 'header-table'
          },
          {
            key: 'tipo_livro',
            label: 'Tipo',
            sortable: true,
            thClass: 'header-table'
          },
          {
            key: 'nome_registrado',
            label: 'Registrado(s)',
            sortable: true,
            thClass: 'header-table'
          },
          {
            key: 'documentos',
            label: 'Doc.',
            sortable: true,
            thClass: 'header-table'
          },
          {
            key: 'acao',
            label: 'Ação',
            sortable: true,
            thClass: 'header-table'
          }
        ]
      }
    },
    watch: {
      selected () {
        this.$emit('onSelectRegisters', this.selected)
      },
      selectedAll () {
        this.toggleAll(this.selectedAll)
      }
    },
    methods: {
      getLabelTipoLivro (value) {
        return findTipoLivroByValue(value).text
      },
      getNomeRegistrado (pessoas) {
        if (!Array.isArray(pessoas)) pessoas = [pessoas]

        if (pessoas.length === 1) {
          return pessoas[0].nome
        }

        if (pessoas.length > 1) {
          return `${pessoas[0].nome || pessoas[0].nome_antigo}<br>${pessoas[1].nome || pessoas[1].nome_antigo}`
        }
      },
      toggleAll (checked) {
        this.allSelected = checked

        this.selected = checked ? this.items.map(item => item) : this.selected = []
      },
      checkBox (item) {
        const findItem = this.selected.findIndex(i => i === item)

        if (findItem < 0) {
          this.selected.push(item)
        } else {
          this.selected.splice(findItem, 1)
        }
      },
      verRegistro (data) {        
        if (data.item.nascimento) {
          return window.open(`nascimento/resumo/${data.item.nascimento.nascimento_id}`)
        }
        if (data.item.casamento) {
          return window.open(`casamento/resumo/${data.item.casamento.casamento_id}`)
        }
        if (data.item.obito) {
          return window.open(`obito/resumo/${data.item.obito.obito_id}`)
        }
      }
    }
  }
</script>
<style lang="scss" scope>
  .header-table {
    background-color: #01bfa5;
    font-size: 18px;
  }

</style>

